import React from "react";
import { Remarkable } from "remarkable";
import { slugToCountryPathname } from "../../utils/strings";
import { GlobalStore } from "../../stores/global";
const markdown = new Remarkable();

const HeroCall = ({ content }) => {
  const currentCountry = GlobalStore.useState(s => s.currentCountry);
  const {
    header,
    description,
    heroimage,
    callusbuttonlabel,
    callusbuttonlink,
    downloadtheapp,
    featureText,
    featureImage,
    featureLinearGradient
  } = content;
  return (
    <div id="HeroCall">
      <div className="wrap">
        <div className="heroImage">
          <img src={heroimage.url} alt="heroImage" />
        </div>
        <div className="infoContainer">
          <div className="contentContainer">
            <div className="header">{header}</div>
            <div className="description" dangerouslySetInnerHTML={{ __html: description }} />
            <div className="btnContainer">
              <div className="btn callUs">
                <a
                  href={
                    callusbuttonlink !== null && callusbuttonlink.trim().length > 0
                      ? slugToCountryPathname(callusbuttonlink)
                      : currentCountry.phoneNumberLink
                  }>
                  <span>{callusbuttonlabel}</span>
                </a>
              </div>
              <div className="btn downloadTheApp">
                <a href={slugToCountryPathname(downloadtheapp.link)}>{downloadtheapp.label}</a>
              </div>
            </div>
          </div>
          <div className="featureWrap">
            <div className="childHeroImage">
              <img src={heroimage.url} alt="heroImage" />
            </div>
            <div className="featureContainer" style={{ "--feature-linear-gradient": featureLinearGradient }}>
              <div className="featureText">{featureText}</div>
              <div className="featureImage">
                <img src={featureImage.url} alt="featureImage" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroCall;
